var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMobileSidebar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.095 4.17C30.15 3.42 28.905 3 27.6 3H13.86C14.325 3.81 14.595 4.74 14.67 5.7H27.615C28.305 5.7 28.965 5.91 29.43 6.285C29.805 6.585 30.015 6.975 30.015 7.35V28.35C30.015 28.74 29.805 29.115 29.43 29.415C28.965 29.79 28.305 30 27.615 30H14.655C14.58 30.96 14.325 31.89 13.845 32.7H27.585C28.89 32.7 30.135 32.28 31.08 31.53C32.1 30.72 32.685 29.55 32.685 28.35V7.35C32.685 6.15 32.1 4.995 31.08 4.17H31.095Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.85 1.5H4.35C3.6 1.5 3 2.1 3 2.85V32.85C3 33.6 3.6 34.2 4.35 34.2H8.85C10.02 34.2 11.16 33.675 11.97 32.775C12.765 31.905 13.2 30.735 13.2 29.52V6.18C13.2 4.95 12.765 3.795 11.97 2.925C11.16 2.025 10.02 1.5 8.85 1.5ZM8.85 26.7H7.35C6.6 26.7 6 26.1 6 25.35C6 24.6 6.6 24 7.35 24H8.85C9.6 24 10.2 24.6 10.2 25.35C10.2 26.1 9.6 26.7 8.85 26.7ZM8.85 21.705H7.35C6.6 21.705 6 21.105 6 20.355C6 19.605 6.6 19.005 7.35 19.005H8.85C9.6 19.005 10.2 19.605 10.2 20.355C10.2 21.105 9.6 21.705 8.85 21.705ZM8.85 16.71H7.35C6.6 16.71 6 16.11 6 15.36C6 14.61 6.6 14.01 7.35 14.01H8.85C9.6 14.01 10.2 14.61 10.2 15.36C10.2 16.11 9.6 16.71 8.85 16.71ZM8.85 11.715H7.35C6.6 11.715 6 11.115 6 10.365C6 9.615 6.6 9.015 7.35 9.015H8.85C9.6 9.015 10.2 9.615 10.2 10.365C10.2 11.115 9.6 11.715 8.85 11.715Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMobileSidebar);
export default __webpack_public_path__ + "static/media/ic-mobile-sidebar.c783a0196fee1cb07cedb5f83278dc0d.svg";
export { ForwardRef as ReactComponent };